// generate APA standard citation format

function getApaEdition(tags) {
    return Object.prototype.hasOwnProperty.call(tags, 'edition') ? `(${tags.edition.join(', ')})` : '';
}
function getApaAuthors(tags) {
    return Object.prototype.hasOwnProperty.call(tags, 'author') ? tags.author.join(', ') : '';
}
function _getApaCountry(tags) {
    return Object.prototype.hasOwnProperty.call(tags, 'country') ? `${tags.country.join(', ')}: ` : '';
}
function getApaPublisher(tags) {
    return Object.prototype.hasOwnProperty.call(tags, 'publisher') ? tags.publisher.join(', ') : '';
}
function getApaPublicationDate(issue) {
    return Object.prototype.hasOwnProperty.call(issue, 'publication_date') ? `(${issue.publication_date})` : '';
}
function getApaTitle(issue, title) {
    return Object.prototype.hasOwnProperty.call(issue, 'title') && issue.title.length ? issue.title : title;
}
function getApaIssueUrl(issue, currentLocation, isEpub = false) {
    const location = isEpub ? btoa(JSON.stringify(currentLocation)) : currentLocation;
    return Object.prototype.hasOwnProperty.call(issue, 'issue_url') > 0
        ? `${issue.issue_url}?location=${location}`
        : '';
}

function formatValue(string) {
    const trimmedString = string.trim();
    if (!trimmedString) {
        return '';
    }
    return trimmedString.endsWith('.') ? `${trimmedString} ` : `${trimmedString}. `;
}

const ApaCitation = (text, issue, currentLocation, issueTitle, isEpub) => {
    const author = getApaAuthors(issue.tags);
    const date = getApaPublicationDate(issue);
    const title = getApaTitle(issue, issueTitle);
    const edition = getApaEdition(issue.tags);
    const publisher = getApaPublisher(issue.tags);
    const url = getApaIssueUrl(issue, currentLocation, isEpub);

    const citation = `${formatValue(author)}${formatValue(date)}${formatValue(title)}${formatValue(edition)}${formatValue(publisher)}${url}`;

    if (text && text.trim()) {
        return `"${text}"

${citation}`;
    }

    return citation;
};

export default ApaCitation;
